import { PresetData, ElementPresetData, ShadersPresetData } from './presets';
import store from '@/store';
import Element from './element';

export class PresetCreator {
    public create(): PresetData {
        const elementPresets = this.createElementPresets();
        const shaderPresets = this.createShaderPresets();
        return new PresetData(
            shaderPresets,
            elementPresets,
        );
    }

    private createElementPresets(): ElementPresetData[] {
        const elements: Element[] = store.getters.scene.elements;
        const elementPresets: ElementPresetData[] =
            elements.map((element: Element) =>
                new ElementPresetData(
                    element.model,
                    element.light,
                    element.type,
                    element.specyficType,
                    element.shaderName,
                    element.position,
                    element.shape,
                    element.center,
                    element.rotation,
                    element.slot,
                ),
            );
        elements.forEach((element: Element, i: number) => {
            const preset = elementPresets[i];
            element.bindings.forEach((binding) => {
                const index = elements.indexOf(binding);
                preset.bindings.push(index);
            });
        });
        return elementPresets;
    }

    private createShaderPresets(): ShadersPresetData {
        const shaders: any = store.getters.shaders;
        return new ShadersPresetData(
            shaders.selectedHandle.shader.key,
            shaders.selectedFront.key,
            shaders.selectedWall.key,
            shaders.selectedShelf.key,
            shaders.selectedBody.key,
            shaders.selectedLegs.shader.key,
            shaders.selectedRafix.key,
            shaders.selectedSupport.key,
            shaders.selectedFrame.key,
        );
    }
}
